import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../../components/Loader'
import { useTasks } from '../../../hooks/Others/Audit/useTask'
import AddTask from './AddTask'

export default function EditTask() {
  const { getTask, task, loading } = useTasks()
  const params = useParams()

  useEffect(() => {
    getTask({ _id: params.taskId })
  }, [params.taskId])

  return <> {loading ? <Loader /> : <AddTask task={task} />} </>
}
